export default __webpack_public_path__ + "static/media/P944_CoC.270c6494.pdf";